import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Brand from "./pages/Brand";
import Admin from "./pages/Admin";
import Manage from "./pages/Manage";
import WebDev from "./pages/WebDev";
import PaymentResult from "./pages/PaymentResult";

export default function App() {
    return (
        <BrowserRouter>
            <Toaster position="top-center" />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services/web-development" element={<WebDev />} />
                <Route path="/brand" element={<Brand />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/manage/:bookingId" element={<Manage />} />
                <Route path="/payment/success" element={<PaymentResult mode="success" />} />
                <Route path="/payment/cancel" element={<PaymentResult mode="cancel" />} />
            </Routes>
        </BrowserRouter>
    );
}
